import { faInbox } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import i18n, { Ti18nKeys } from "../../constants/i18n";
import Et3Collapsible from "../et3-collapsible";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import { colors } from "../et3-theme/colors";
import {
  TABLE_EMPTY_BODY_HEIGHT,
  TABLE_BORDER,
  TABLE_SHADOW,
  TABLE_EMPTY_FONT_SIZE,
  TABLE_EMPTY_GAP,
  TABLE_EMPTY_ICON_SIZE,
  TABLE_RADIUS_CSS
} from "./table-constants";
import TableTitle from "./TableTitle";

const EmptyTable = withLiteObserverAndTheme<{
  width: number;
  title: string;
  emptyMessageKey?: Ti18nKeys;
  isCollapsible: boolean;
  sectionId: string;
  defaultOpen: boolean;
  rowsCount: number;
}>((props) => {
  const {
    width,
    title,
    emptyMessageKey,
    isCollapsible,
    sectionId,
    defaultOpen,
    rowsCount,
    theme
  } = props;
  const { unitX, unitY } = theme;

  const emptyStateBody = (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={width}
      height={TABLE_EMPTY_BODY_HEIGHT}
      fDirection={"column"}
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        width: "100%",
        gap: TABLE_EMPTY_GAP * unitY
      }}
      alignItems="center"
      justifyContent="center"
      onClick={() => {}}
    >
      <FontAwesomeIcon
        icon={faInbox}
        color={colors.all.lightGray}
        style={{
          width: TABLE_EMPTY_ICON_SIZE * unitX,
          height: TABLE_EMPTY_ICON_SIZE * unitY
        }}
      />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={TABLE_EMPTY_FONT_SIZE}
        text={i18n.get(emptyMessageKey ?? "NO_RESULT")}
        isSpan={false}
        color={colors.all.davysGrey}
        style={{ margin: 0 }}
      />
    </ET3Div>
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection={"column"}
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        border: TABLE_BORDER,
        borderRadius: TABLE_RADIUS_CSS,
        boxShadow: TABLE_SHADOW,
        overflow: "hidden"
      }}
      alignItems="stretch"
      justifyContent="flex-start"
      onClick={() => {}}
    >
      <TableTitle
        width={width}
        title={title}
        isCollapsible={isCollapsible}
        sectionId={sectionId}
        defaultOpen={defaultOpen}
        rowsCount={rowsCount}
      />
      {isCollapsible ? (
        <Et3Collapsible sectionId={sectionId} defaultOpen={defaultOpen}>
          {emptyStateBody}
        </Et3Collapsible>
      ) : (
        emptyStateBody
      )}
    </ET3Div>
  );
});
export default EmptyTable;
